import { useState, useEffect /*useRef*/ } from "react";
import { useSearchParams } from "react-router-dom";

import { getBundles } from "../../services/bundle";

import { getFirstCorrectImage } from "../../helpers/global";

import { BUNDLE_CRUMBS } from "../../constants/crumbs";

import BundleCard from "../BundleCard/BundleCard";
// import Pagination from "../Pagination/Pagination";
import PortalBreadcrumb from "../UI/Breadcrumb/PortalBreadcrumb/PortalBreadcrumb";
import Loading from "../UI/Loading/Loading";
import EmptyContent from "../UI/EmptyContent/EmptyContent";

import classes from "./Bundles.module.css";

const Bundles = () => {
  const [bundles, setBundles] = useState([]);
  //   const [bundlesTotalCount, setBundlesTotalCount] = useState(0);
  //   const [pageNumber, setPageNumber] = useState(0);
  //   const [pageLimit] = useState();
  const [isBundlesLoading, setIsBundlesLoading] = useState(true);
  const [bundlesLoadingError, setBundlesLoadingError] = useState("");

  //   const mainContentRef = useRef();
  const [searchParams] = useSearchParams();
  const skuIdQueryParam = searchParams.get("skuId");

  //   const scrollToMainContentSection = () => {
  //     mainContentRef?.current.scrollIntoView({ behavior: "smooth" });
  //   };

  //   const currentPageChangedHandler = (pageNumber) => {
  //     setPageNumber(pageNumber);
  //     scrollToMainContentSection();
  //   };

  useEffect(() => {
    const fetchBundles = async () => {
      const params = {};
      if (skuIdQueryParam && !isNaN(parseInt(skuIdQueryParam))) {
        params.skuId = skuIdQueryParam;
      }
      try {
        setIsBundlesLoading(true);
        setBundlesLoadingError("");
        const response = await getBundles(params);
        const {
          data: { data: bundles },
        } = response;
        setBundles(bundles);
        // setBundlesTotalCount(1);
      } catch (err) {
        setBundlesLoadingError("لا يوجد عروض !");
      } finally {
        setIsBundlesLoading(false);
      }
    };

    fetchBundles();
  }, [skuIdQueryParam]);

  return (
    <div className={classes["bundles"]}>
      <PortalBreadcrumb paths={BUNDLE_CRUMBS} />
      <section className={classes["bundles-grid"]}>
        {isBundlesLoading ? (
          <Loading className={classes["bundles-grid__loading"]} />
        ) : bundlesLoadingError || bundles.length === 0 ? (
          <EmptyContent
            message="لا يوجد عروض !"
            className={classes["bundles-grid__empty"]}
          />
        ) : (
          <>
            {bundles.map((bundle, index) => (
              <BundleCard
                key={index}
                id={bundle.id}
                bundleSkus={bundle.skuList}
                name={bundle.name}
                price={bundle.priceBeforeDiscount - bundle.discount}
                images={bundle.skuList.map((sku) =>
                  getFirstCorrectImage(sku.images)
                )}
              />
            ))}
            {/* <Pagination
              className={classes["bundles-grid__pagination"]}
              currentPage={pageNumber}
              pageSize={pageLimit}
              total={bundlesTotalCount}
              onPageChange={currentPageChangedHandler}
            /> */}
          </>
        )}
      </section>
    </div>
  );
};

export default Bundles;
